var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"announcement-wrapper"},[_c('InfoList',{attrs:{"data":_vm.announcementList,"visited":_vm.visitedAnnouncement,"busy":_vm.busy},on:{"load":_vm.getAnnouncementList,"to":_vm.goPage}}),_c('LoadMoreButton',{attrs:{"finished":_vm.finished,"loading":_vm.loading},on:{"click":_vm.getAnnouncementList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }